var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.125H1.5",
    stroke: "#181717",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.75V12C16.5 10.5858 16.5 9.8787 16.0606 9.43935C15.6213 9 14.9142 9 13.5 9H4.5C3.08578 9 2.37868 9 1.93934 9.43935C1.5 9.8787 1.5 10.5858 1.5 12V15.75",
    stroke: "#181717",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9V7.66005C8.25 7.37454 8.2071 7.27906 7.98727 7.16653C7.52962 6.93219 6.97399 6.75 6.375 6.75C5.77601 6.75 5.22041 6.93219 4.76269 7.16653C4.54291 7.27906 4.5 7.37454 4.5 7.66005V9",
    stroke: "#181717",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9V7.66005C13.5 7.37454 13.4571 7.27906 13.2373 7.16653C12.7796 6.93219 12.224 6.75 11.625 6.75C11.026 6.75 10.4704 6.93219 10.0127 7.16653C9.7929 7.27906 9.75 7.37454 9.75 7.66005V9",
    stroke: "#181717",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9V5.52043C15.75 5.0017 15.75 4.74233 15.6059 4.4974C15.4618 4.25246 15.2565 4.12568 14.8458 3.87212C13.1902 2.84983 11.1745 2.25 9 2.25C6.8255 2.25 4.80986 2.84983 3.15419 3.87212C2.74353 4.12568 2.5382 4.25246 2.3941 4.4974C2.25 4.74233 2.25 5.0017 2.25 5.52043V9",
    stroke: "#181717",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.49af2c255ede686b3a2e039863c1cfed.svg";
export { ForwardRef as ReactComponent };